"use client";

import { c as _c } from "react/compiler-runtime";
import { useContext, useEffect, useState } from "react";
import type { ApiProfileRepRatesState } from "@/entities/IProfile";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import { AuthContext } from "@/components/auth/Auth";
import { ApiProfileProxyActionType } from "@/generated/models/ApiProfileProxyActionType";
import { useQuery } from "@tanstack/react-query";
import { commonApiFetch } from "@/services/api/common-api";
import Link from "next/link";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
export default function UserPageRepNewRepSearchHeader(t0) {
  const $ = _c(52);
  const {
    repRates,
    profile
  } = t0;
  const {
    activeProfileProxy
  } = useContext(AuthContext);
  const t1 = activeProfileProxy?.created_by.handle;
  const t2 = profile?.handle;
  let t3;
  if ($[0] !== t1 || $[1] !== t2) {
    t3 = [QueryKey.PROFILE_REP_RATINGS, {
      rater: t1,
      handleOrWallet: t2
    }];
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== activeProfileProxy || $[4] !== profile.query) {
    t4 = async () => await commonApiFetch({
      endpoint: `profiles/${profile?.query}/rep/ratings/received`,
      params: activeProfileProxy?.created_by.handle ? {
        rater: activeProfileProxy.created_by.handle
      } : {}
    });
    $[3] = activeProfileProxy;
    $[4] = profile.query;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = !!activeProfileProxy?.created_by.handle;
  let t6;
  if ($[6] !== t3 || $[7] !== t4 || $[8] !== t5) {
    t6 = {
      queryKey: t3,
      queryFn: t4,
      enabled: t5
    };
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const {
    data: proxyGrantorRepRates
  } = useQuery(t6);
  let t7;
  if ($[10] !== activeProfileProxy?.actions || $[11] !== proxyGrantorRepRates || $[12] !== repRates?.rep_rates_left_for_rater || $[13] !== repRates?.total_rep_rating_by_rater) {
    t7 = () => {
      const repProxy = activeProfileProxy?.actions.find(_temp);
      if (!repProxy) {
        return {
          available: repRates?.rep_rates_left_for_rater ?? 0,
          rated: repRates?.total_rep_rating_by_rater ?? 0,
          proxyCreditLeft: null
        };
      }
      if (!proxyGrantorRepRates) {
        return {
          available: 0,
          rated: 0,
          proxyCreditLeft: null
        };
      }
      const proxyGrantorAvailableRep = proxyGrantorRepRates.rep_rates_left_for_rater ?? 0;
      const proxyGrantorTotalRep = proxyGrantorRepRates.total_rep_rating_by_rater ?? 0;
      return {
        available: proxyGrantorAvailableRep,
        rated: proxyGrantorTotalRep,
        proxyCreditLeft: Math.max(0, (repProxy.credit_amount ?? 0) - (repProxy.credit_spent ?? 0))
      };
    };
    $[10] = activeProfileProxy?.actions;
    $[11] = proxyGrantorRepRates;
    $[12] = repRates?.rep_rates_left_for_rater;
    $[13] = repRates?.total_rep_rating_by_rater;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const getActiveRepRates = t7;
  let t8;
  if ($[15] !== getActiveRepRates) {
    t8 = getActiveRepRates();
    $[15] = getActiveRepRates;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  const [activeRepRates, setActiveRepRates] = useState(t8);
  let t9;
  if ($[17] !== getActiveRepRates) {
    t9 = () => setActiveRepRates(getActiveRepRates());
    $[17] = getActiveRepRates;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== activeProfileProxy || $[20] !== proxyGrantorRepRates || $[21] !== repRates) {
    t10 = [activeProfileProxy, proxyGrantorRepRates, repRates];
    $[19] = activeProfileProxy;
    $[20] = proxyGrantorRepRates;
    $[21] = repRates;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  useEffect(t9, t10);
  let t11;
  if ($[23] !== activeProfileProxy || $[24] !== activeRepRates.available || $[25] !== activeRepRates.proxyCreditLeft) {
    t11 = () => {
      if (!activeProfileProxy) {
        return activeRepRates.available;
      }
      return Math.abs(activeRepRates.available) < Math.abs(activeRepRates.proxyCreditLeft ?? 0) ? activeRepRates.available : activeRepRates.proxyCreditLeft ?? 0;
    };
    $[23] = activeProfileProxy;
    $[24] = activeRepRates.available;
    $[25] = activeRepRates.proxyCreditLeft;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  const getAvailableCredit = t11;
  let t12;
  if ($[27] !== getAvailableCredit) {
    t12 = getAvailableCredit();
    $[27] = getAvailableCredit;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  const [availableCredit, setAvailableCredit] = useState(t12);
  let t13;
  if ($[29] !== getAvailableCredit) {
    t13 = () => setAvailableCredit(getAvailableCredit());
    $[29] = getAvailableCredit;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== activeRepRates) {
    t14 = [activeRepRates, activeRepRates.proxyCreditLeft];
    $[31] = activeRepRates;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  useEffect(t13, t14);
  let t15;
  if ($[33] !== activeProfileProxy) {
    t15 = !!activeProfileProxy && <span className="tw-text-base tw-block tw-text-iron-300 tw-font-normal"><span>You are acting as proxy for:</span><span className="tw-ml-1 tw-font-semibold tw-text-iron-50"><Link href={`/${activeProfileProxy.created_by.handle}`}>{activeProfileProxy.created_by.handle}</Link></span></span>;
    $[33] = activeProfileProxy;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== activeProfileProxy || $[36] !== availableCredit) {
    t16 = !activeProfileProxy && <span className="tw-text-base tw-block tw-text-iron-300 tw-font-normal"><span>Your available Rep:</span><span className="tw-ml-1 tw-font-semibold tw-text-iron-50">{formatNumberWithCommas(availableCredit)}</span></span>;
    $[35] = activeProfileProxy;
    $[36] = availableCredit;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  const t17 = profile.query ?? profile.handle ?? profile.display;
  let t18;
  if ($[38] !== t17) {
    t18 = <span>Your Rep assigned to{" "}{t17}:</span>;
    $[38] = t17;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] !== activeRepRates.rated || $[41] !== repRates) {
    t19 = repRates ? formatNumberWithCommas(activeRepRates.rated) : "";
    $[40] = activeRepRates.rated;
    $[41] = repRates;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  let t20;
  if ($[43] !== t19) {
    t20 = <span className="tw-ml-1 tw-font-semibold tw-text-iron-50">{t19}</span>;
    $[43] = t19;
    $[44] = t20;
  } else {
    t20 = $[44];
  }
  let t21;
  if ($[45] !== t18 || $[46] !== t20) {
    t21 = <span className="tw-text-base tw-block tw-text-iron-300 tw-font-normal">{t18}{t20}</span>;
    $[45] = t18;
    $[46] = t20;
    $[47] = t21;
  } else {
    t21 = $[47];
  }
  let t22;
  if ($[48] !== t15 || $[49] !== t16 || $[50] !== t21) {
    t22 = <div className="tw-flex tw-flex-col tw-space-y-1">{t15}{t16}{t21}</div>;
    $[48] = t15;
    $[49] = t16;
    $[50] = t21;
    $[51] = t22;
  } else {
    t22 = $[51];
  }
  return t22;
}
function _temp(a) {
  return a.action_type === ApiProfileProxyActionType.AllocateRep;
}